import { render, staticRenderFns } from "./ContactServerBtn.vue?vue&type=template&id=49322ddc&scoped=true&"
import script from "./ContactServerBtn.vue?vue&type=script&lang=js&"
export * from "./ContactServerBtn.vue?vue&type=script&lang=js&"
import style0 from "./ContactServerBtn.vue?vue&type=style&index=0&id=49322ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49322ddc",
  null
  
)

export default component.exports